import React from 'react';
import {
  Box,
  Grid,
  LinearProgress,
  linearProgressClasses,
  Typography,
} from '@mui/material';
import { colors } from '../../../../theme/theme';
import EyeIcon from '../../../../components/Icons/EyeIcon';
import { styled } from '@mui/material/styles';
import { ProfileScoreCategory } from '../../../../interfaces/gamification.interface';
import ProfileScoreCategoryList from './ProfileScoreCategoryList';

interface IProfileScoreMenu {
  points: number;
  percentage: number;
  profileScoreCategory: ProfileScoreCategory[];
}

const ProfileScoreMenu = (props: IProfileScoreMenu) => {
  const { percentage, profileScoreCategory, points } = props;

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      sx={{ bgcolor: colors.white }}
    >
      <Grid
        container
        className="profile-score-header-container"
        direction="column"
        color={colors.bgDark}
        sx={{ p: '22px 16px' }}
      >
        <Grid container item pb="16px" alignItems={'center'}>
          <Grid
            container
            flex={1}
            justifyContent="center"
            display="flex"
            flexDirection="column"
          >
            <Typography variant="subtitle1">Your Profile Score</Typography>
            <Grid
              container
              columnGap="6px"
              sx={{
                alignItems: 'center',
              }}
            >
              <Grid item display="flex" alignItems="flex-end">
                <EyeIcon />
              </Grid>
              <Grid item>
                <Typography variant="caption" color={colors.dark60}>
                  Only Visible To You
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Typography variant="h1" color={'palette.secondary'}>
              {Math.round(points)}
            </Typography>
          </Grid>
        </Grid>
        <Grid item>
          <BorderLinearProgress variant="determinate" value={percentage} />
        </Grid>
      </Grid>
      {profileScoreCategory && profileScoreCategory.length > 0 && (
        <ProfileScoreCategoryList profileScoreCategory={profileScoreCategory} />
      )}
    </Box>
  );
};

export default ProfileScoreMenu;

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: '#3ACC40',
  },
}));
